import PropTypes from 'prop-types';
import AccommodationCard from '~/js/components/accommodations/AccommodationCard';
import Modal from '~/js/components/global/Modal';
import FeatureTooltips from '~/js/components/accommodations/FeatureTooltips';
import ReactLoader from '~/js/components/global/ReactLoader';

const { PureComponent, Fragment } = window.React;
const internals = {};

internals.roomDetailURI = {
  btc: '/resorts/turks-caicos/rooms/',
  bng: '/resorts/negril/rooms/',
  bbo: '/resorts/ocho-rios/rooms/'
};

export class CardsContainer extends PureComponent {
  static propTypes = {
    resortCode: PropTypes.string.isRequired,
    accomodationTitle: PropTypes.string,
    filterRoomsArray: PropTypes.array,
    isFiltered: PropTypes.bool
  };

  static defaultProps = {
    resortCode: '',
    accomodationTitle: '',
    filterRoomsArray: [],
    isFiltered: true
  };

  constructor(props) {
    super(props);

    this.state = {
      isListView: window.innerWidth > 767,
      modalTitle: '',
      modalDetails: ''
    };
  }

  componentDidMount = () => {
    this.getFilteredAccommodations();

    window.addEventListener('resize', _globalUtils.debounce(() => {

      if (window.innerWidth < 768 && this.state.isListView) {
        this.setState({ isListView: false });
      } else if(window.innerWidth > 768) {
        window.$.magnificPopup.close();
      }
    }, 200));
  }

  componentDidUpdate = (prevProps) => {
    const { filters, tab } = this.props;

    if(JSON.stringify(filters) !== JSON.stringify(prevProps.filters) || tab !== prevProps.tab) {
      this.getFilteredAccommodations();
    }
  };

  getFilteredAccommodations = () => {
    const { accommodations } = this.props;
    const filteredAccommodations = accommodations.filter(accommodation => {
      const containsAccommodation = this.containsFilter(accommodation);
      const containsVillage = this.containsVillage(accommodation);
      const containsOccupants = this.containsOccupants(accommodation);
      const containsTab = this.props.isDisabledByTab(accommodation);

      return containsTab && containsVillage && containsOccupants && containsAccommodation;
    });

    this.props.setFilteredAccommodations(filteredAccommodations);
  }

  containsFilter = (accommodation) => {
    const { filters } = this.props;
    const filterTypes = ['views', 'amenities', 'promotions'];
    const allActiveFilters = filterTypes.reduce((accu, curr) => [ ...accu, ...filters[curr] ], []);
    const allAccommodationAmenities = filterTypes.reduce((accu, curr) => {

      let value = [];

      if (curr === 'views') {
        value = accommodation[curr];
      }
      if (curr === 'amenities') {
        value = accommodation[curr].map((el) => el.name);
      }
      if (curr === 'promotions') {
        value = accommodation[curr].map((el) => el.title);
      }

      return [ ...accu, ...value ];
    }, []);

    const contained = allActiveFilters.every(filter => {
      return typeof allAccommodationAmenities.find(accommodationFilter => {
        return accommodationFilter === filter;
      }) !== 'undefined';
    });

    return contained;
  }

  containsVillage = (accommodation) => {
    const { filters } = this.props;
    const contained = typeof filters.villages.find(village => village === accommodation.groupCode) !== 'undefined';

    return contained ? true : filters.villages.length === 0;
  }

  containsOccupants = (accommodation) => {
    const { filters } = this.props;

    // last conditional of return statement validates that if maxAdults is not 0 (default for categories) then only return rooms that allow more adults than what is selected in the filter
    return accommodation.maxOccupants >= parseInt(filters.adults, 10) + parseInt(filters.children, 10) && (accommodation.maxAdults === 0 || accommodation.maxAdults >= parseInt(filters.adults, 10));
  }

  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _updateView = (isListView = false) => () => this.setState({ isListView });

  render() {
    const modalId = 'mdl-promotion';
    const { isListView } = this.state;
    const { status } = this.props;

    return (
      <div className="cards-container">
        {
          {
            error: (<span className="txt-center display-block">An error has ocurred, please refresh this page and try again</span>),
            loading: (<ReactLoader className="sk-loader-accommodation-level"/>),
            success: (<Fragment>
              <div className="row center-xs">
                <div className="finding-room xs-12">
                  <div className="xs-12 xl-10 xl-offset-1 white">
                    <div className="row">
                      <div className="copy xs-12 xl-9">
                        <h3>Not finding the room you want?<span> Let us help you!</span></h3>
                        <p>If you’re not finding available dates for the room you want, please click here to chat with an agent.</p>
                      </div>
                      <div className="button xs-12 xl-3">
                      {<a data-moxie-rule-name="standard chat" data-moxie-start-engagement="chat" datamoxie-portal-id="201" data-moxie-host="https://unique-vacations.ehosts.net" className="btn btn-blue">Chat Now</a>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xs-12 txt-left pr">
                  <h3 className="accommodation-ttl inline-block color-blue">
                    <div className="xs-9 lg-12 accommodations-found">
                      {this.props.filteredAccommodations.length} rooms found
                      <span className="opensans-semibold uppercase">
                        {`under ${this.props.accomodationTitle}`}
                      </span>
                    </div>
                    <div className="xs-3 ib refine">
                      <a href="#refine" className="js-magnific-popup">
                        <span className="icon-refine"/>
                        <span className="show">REFINE</span>
                      </a>
                    </div>
                  </h3>
                  <div className="inline-block grid-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView() } className="change-view color-acacac">
                      <i className={`icon-grid-view ${ (!isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">GRID VIEW</span>
                    </div>
                  </div>
                  <div className="inline-block list-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView(true) } className="change-view color-acacac">
                      <i className={`icon-list-view ${ (isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">LIST VIEW</span>
                    </div>
                  </div>
                </div>
                <div className="tooltip_templates hide">
                  <FeatureTooltips />
                </div>
                {
                  this.props.filteredAccommodations.map(
                    (room) => (<AccommodationCard
                      key={room.code}
                      roomInformation={room}
                      isListView={this.state.isListView}
                      modalId={modalId}
                      updateModal={this._updateModal}
                      villageCode={this.props.resortData.code}
                      roomDetailURI={internals.roomDetailURI}
                      isFiltered={this.props.isFiltered}
                    />))
                }
                <Modal id={modalId} title={this.state.modalTitle} content={this.state.modalDetails} />
              </div>
            </Fragment>)
          }[status]
        }
      </div>
    );
  }
}

export default CardsContainer;
